const productionDomain = "https://filmpoland.pl";
const developmentSubfolder = "/filmpoland";
export const config = {
    domain: process.env.NODE_ENV === "development" ? "http://localhost" : productionDomain,
    domainRelPath: process.env.NODE_ENV === "development" ? developmentSubfolder : "",
};
export default config;